import { useCallback, useMemo } from 'react';
import cookies from 'react-cookies';

export const useCookieAuth = () => {
  const setToken = useCallback((token: string, COOKIE_NAME: string) => {
    cookies.save(COOKIE_NAME, token, {
      path: '/',
    });
  }, []);

  const getToken = useCallback((COOKIE_NAME: string) => {
    return cookies.load(COOKIE_NAME);
  }, []);

  const removeToken = useCallback((COOKIE_NAME: string) => {
    cookies.remove(COOKIE_NAME, { path: '/' });
  }, []);

  return useMemo(() => ({ setToken, getToken, removeToken }), [setToken, getToken, removeToken]);
};
